<template>
  <div class="signup-container">
    <div class="signup-card">
      <!-- Icon -->
      <div class="signup-icon">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
          <path d="M19 21V19C19 17.9391 18.5786 16.9217 17.8284 16.1716C17.0783 15.4214 16.0609 15 15 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <circle cx="10" cy="7" r="4" stroke="currentColor" stroke-width="2"/>
          <path d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>

      <!-- Header -->
      <div class="signup-header">
        <h1 class="signup-title">{{ headerText }}</h1>
        <p class="signup-subtitle">{{ subHeaderText }}</p>
      </div>

      <!-- Form -->
      <DataCollectionForm @submitData="submitData" class="signup-form" />

      <!-- Footer -->
      <div class="signup-footer">
        <span class="signup-footer__text">Wrong product type?</span>
        <router-link to="/onboarding/account-type" class="signup-footer__link">
          Change selection
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import DataCollectionForm from "@/components/onboarding/forms/DataCollectionForm.vue";
import { getItem, removeItem, setItem, clearStorage } from "@/utils/storage.js";
import { removeDash } from "@/utils/helpers.js";
import responseHandler from "@/utils/responseHandler.js";
import api from "@/utils/api.js";

export default {
  name: "DataCollection",

  components: { DataCollectionForm },

  data() {
    return {
      type: "",
      headerText: "",
      subHeaderText: "",
    };
  },

  created() {
    this.setHeader();
    this.setSubHeader();
  },

  methods: {
    ...mapActions("organisationModule", ["getOrganisationProfile"]),
    ...mapActions("loadingModule", ["createSuccess", "createLoading"]),
    ...mapActions(["showToast"]),

    async submitData(payload) {
      this.createLoading(true);
      try {
        const response = await api.createOrganisation(payload);
        const { data, message, status } = response.data;
        if (status === "success") {
          this.createSuccess(true);
          this.showToast({
            description: message,
            display: true,
            type: "success",
          });
          setItem("org_token", data.token);
          const response = await this.getOrganisationProfile(data._id);
          if (response)
            this.$router.push({
              name: "CodeVerification",
              params: { type: this.$route.params.type },
            });
          if (!response) {
            clearStorage();
            this.$router.push({ name: "SignIn" });
          }
          this.createLoading(false);
        }
      } catch (error) {
        responseHandler.handleError(error);
        this.createLoading(false);
        clearStorage();
        this.$router.push({ name: "SignIn" });
      }
    },

    setSubHeader() {
      this.subHeaderText = `Start listing today`;
      let subHeaderText = null;
      switch (this.$route.params.type) {
        case "private-raise":
          subHeaderText = `Start raising today`;
          break;
        case "employee-benefit":
          subHeaderText = `Manage your employee stock benefits`;
          break;
        case "public-raise":
          subHeaderText = `Start listing today`;
          break;
        case "invest":
          subHeaderText = `Start investing today`;
          break;
      }
      this.subHeaderText = subHeaderText;
    },

    setHeader() {
      this.headerText = `Create your account`;
    },
  },
};
</script>

<style lang="scss" scoped>
.signup-container {
  width: 100%;
  max-width: 480px;
  padding: 0 16px 40px;
}

.signup-card {
  background: white;
  border-radius: 16px;
  padding: 40px 32px;
  box-shadow: 0 4px 24px rgba(15, 23, 42, 0.06);
  border: 1px solid #E2E8F0;

  @media (max-width: 480px) {
    padding: 32px 24px;
    border-radius: 12px;
  }
}

.signup-icon {
  width: 56px;
  height: 56px;
  background: linear-gradient(135deg, #EBF2FF 0%, #F0F6FF 100%);
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4D84FF;
  margin: 0 auto 24px;
}

.signup-header {
  text-align: center;
  margin-bottom: 32px;
}

.signup-title {
  font-family: 'DM Sans', sans-serif;
  font-size: 26px;
  font-weight: 500;
  color: #0F172A;
  margin: 0 0 8px 0;
  letter-spacing: -0.02em;
}

.signup-subtitle {
  font-family: 'DM Sans', sans-serif;
  font-size: 15px;
  font-weight: 400;
  color: #64748B;
  margin: 0;
}

.signup-form {
  margin-bottom: 24px;
}

.signup-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;

  &__text {
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #64748B;
  }

  &__link {
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #4D84FF;
    text-decoration: none;
    transition: color 0.15s ease;

    &:hover {
      color: #3B6FE8;
    }
  }
}
</style>
